import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { WEB_COMPONENT_SET_AD_INTEGRATOR } from '../../../../../../webcomponents.constants';
import { translateFn } from '../../../../../../utils/translator.helper';
import { FontSizes, LineHeights } from '../../../../../../types/common/types';
import { AdActionProps } from '../interfaces';
import { htmlEncode } from '../../../../../../utils/escape.utils';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
/**
 * @summary Content of Isolate Endpoint task pop-up.
 * @tag gz-isolate-endpoint-task
 */
@customElement(WEB_COMPONENT_SET_AD_INTEGRATOR)
export class GzSetADIntegratorWebComponent extends LitElement {
  @property({ attribute: true, reflect: true, type: Object })
  adActionProps: AdActionProps;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    if (this.adActionProps.isPartner) {
      return this.renderPartnerContent();
    }

    return html`
      <gz-text lineHeight="${LineHeights.NORMAL}" fontSize="${FontSizes.HEADING_6}">
        ${translateFn('You are about to set {ENDPOINT_NAME} as an AD Integrator.', {
          ENDPOINT_NAME: this.adActionProps.endpointName,
        })}
      </gz-text>
      <gz-info-box severity="warning">
        ${translateFn('Active Directory endpoints should have a policy assigned directly to them.')}</gz-info-box
      >
      <gz-text lineHeight="${LineHeights.NORMAL}" fontSize="${FontSizes.HEADING_6}"
        >${translateFn('When synchronizing with Active Directory:')}</gz-text
      >
      <gz-text lineHeight="${LineHeights.NORMAL}" fontSize="${FontSizes.HEADING_6}">
        <span class="has-bullet bullet-neutral">${translateFn(
          'All discovered endpoints will move to their Active Directory folder.'
        )}</span></gz-text
      >
      <gz-text lineHeight="${LineHeights.NORMAL}" fontSize="${FontSizes.HEADING_6}">
        <span class="has-bullet bullet-neutral">${translateFn(
          'Endpoints with inherited policy will be assigned with the default policy.'
        )}</gz-text
      >
    `;
  }

  renderPartnerContent() {
    if (!this.adActionProps.companyName) {
      throw new Error('Unable to render AD action for partner');
    }

    return html`
      <gz-text lineHeight="${LineHeights.NORMAL}" fontSize="${FontSizes.HEADING_6}">
        ${unsafeHTML(
          translateFn(
            'You are about to set {bold}{ENDPOINT_NAME}{/bold} as an AD Integrator for company {bold}{COMPANY_NAME}{/bold}.',
            {
              ENDPOINT_NAME: htmlEncode(this.adActionProps.endpointName),
              COMPANY_NAME: htmlEncode(this.adActionProps.companyName),
              bold: '<strong>',
              '/bold': '</strong>',
              interpolation: {
                escapeValue: false,
              },
            }
          )
        )}
      </gz-text>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    WEB_COMPONENT_SET_AD_INTEGRATOR: GzSetADIntegratorWebComponent;
  }
}
